<template>
  <div class="for-transition w-100">
    <NotificationPreferences />
  </div>
</template>

<script setup>
  // Таб «Уведомления» в настройках профиля. Секция живёт в модуле notifications
  // и читает store.notifications — роут валиден только в проекте, где модуль
  // notifications инициализирован (методы менеджера кладутся в его actions).
  import NotificationPreferences from '@martyrs/src/modules/notifications/components/sections/NotificationPreferences.vue'
</script>
